// src/utils/permissions.js

export const canEditCompanyInfo = (role) => {
  const r = (role || "").toLowerCase();
  return r === "admin" || r === "hr";
};

export const canViewCompanyInfo = (role) => {
  const r = (role || "").toLowerCase();
  return ["admin", "hr", "member"].includes(r);
};
